









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SignIn extends Vue {
  @Prop() private msg!: string;

  onButtonClicked(): void {
    window.location.href = 'https://server-ui.demo.octonica.com/login'
  }
}
